<template>
  <div
    class="badge"
    :style="{
      backgroundColor: colorCode,
      boxShadow: `0 4px 10px ${colorCode}33`,
      width: width || 'auto',
    }"
  >
    <div class="badge-icon-container" v-if="resolvedIcon">
      <img :src="resolvedIcon" alt="icon" class="badge-icon" />
    </div>
    <div class="badge-text">{{ shipment }}</div>
  </div>
</template>

<script>
export default {
  name: "ShipmentBadge",
  props: {
    colorCode: { type: String, default: "#4f46e5" },
    icon: { type: String, default: "" },
    shipment: { type: [String, Number], required: true },
    width: { type: String, default: "auto" },
  },
  computed: {
    resolvedIcon() {
      if (!this.icon) return null;

      // Handle absolute or external paths
      if (this.icon.startsWith("/") || this.icon.startsWith("http")) {
        return this.icon;
      }

      // Load from static folder (outside src)
      return `/static/img/${this.icon}`;
    },
  },
};
</script>

<style scoped>
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  border: none; /* ❌ remove border */
  border-radius: 5px;
  padding: 0px 16px;
  transition: all 0.2s ease-in-out;
  cursor: default;
}

.badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
}

.badge-icon-container {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  flex-shrink: 0;
}

.badge-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.badge-text {
  color: #fff; /* ✅ white text looks better on colored background */
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ShipmentBadge.vue?f747c6da